export default __webpack_public_path__ + "static/media/SENAIT_NL_SEQ21.085c2d7b.mp3";